<template>
  <DashboardHeaderContainer class="demographics-header">
    <div class="actions-content">
      <div class="build-report">
        <PrimaryButton
          class="show-report-button"
          @click="$emit('filtersEdit')">
          <template slot="icon">
            <SettingsIcon size="small"></SettingsIcon>
          </template>
          Build Report
        </PrimaryButton>
      </div>
      <div class="report-options">
        <DashboardCalendarPicker
          id="demographics-header-calendar"
          :value="localDateValue"
          :minDate="minDate"
          :maxDate="maxDate"
          @click="$emit('dateApply', $event)"
        ></DashboardCalendarPicker>
        <CenterAlignTooltip>
          <IconButton
            class="actions-button"
            @click="copyCurrentUrl">
            <LinkIcon></LinkIcon>
          </IconButton>
          <template v-slot:content>{{ urlCopyText }}</template>
        </CenterAlignTooltip>
        <CenterAlignTooltip>
          <IconButton
            class="actions-button"
            :disabled="!canDownloadReport"
            @click="$emit('downloadClick')"
          >
            <ExportIcon></ExportIcon>
          </IconButton>
          <template v-slot:content>Export as CSV</template>
        </CenterAlignTooltip>
      </div>
    </div>
  </DashboardHeaderContainer>
</template>

<script>
import DashboardHeaderContainer from '../Common/DashboardHeaderContainer.vue';
import DashboardCalendarPicker from '../Common/DashboardCalendarPicker.vue';
import {
  PrimaryButton,
  SettingsIcon,
  CenterAlignTooltip,
  IconButton,
  LinkIcon,
  ExportIcon,
} from '@mikmak/components';

export default {
  props: {
    dateValue: {
      type: Object,
    },
    minDate: {
      type: [Date, Number],
    },
    maxDate: {
      type: [Date, Number],
    },
    canDownloadReport: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      localDateValue: this.dateValue,
      isCopied: false,
    };
  },
  components: {
    DashboardHeaderContainer,
    DashboardCalendarPicker,
    PrimaryButton,
    SettingsIcon,
    CenterAlignTooltip,
    IconButton,
    LinkIcon,
    ExportIcon,
  },
  computed: {
    urlCopyText() {
      return this.isCopied ? 'Copied!' : 'Copy Share Link';
    },
  },
  methods: {
    copyCurrentUrl() {
      const invisibleInput = document.createElement('input');
      const text = window.location.href;

      document.body.appendChild(invisibleInput);
      invisibleInput.value = text;
      invisibleInput.select();
      document.execCommand('copy');
      document.body.removeChild(invisibleInput);

      this.isCopied = true;

      setTimeout(() => {
        this.isCopied = false;
      }, 2000);
    },
  },
  watch: {
    dateValue() {
      this.localDateValue = this.dateValue;
    },
  },
};
</script>

<style>
.demographics-header {
  display: flex;
  justify-content: center;
}

.actions-content {
  height: 100%;
  width: 1360px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.actions-button {
  margin-left: 8px;
}

.build-report {
  padding-left: 20px;
}

.report-options {
  display: flex;
  padding-right: 24px;
}

#demographics-header-calendar {
  width: 300px;
  height: 65%;
  padding-right: 16px;
}

#demographics-header-calendar .picker-container.dropdown {
  right: 0;
  z-index: 2;
}

#demographics-header-calendar .date-range-control-wrapper {
  background: transparent;
}

#demographics-header-calendar .date-range-control {
  background: #FFFFFF;
  cursor: pointer;
}

#demographics-header-calendar .help-text {
  background: transparent;
  padding: 0 12px;
  z-index: 2;
}

.actions-button.disabled {
  pointer-events: none;
}
</style>
